/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiAgentConfigShow } from '../../axios/whatsAppAiAgentConfigShow'
import type {
	WhatsAppAiAgentConfigShowError,
	WhatsAppAiAgentConfigShowPathParams,
	WhatsAppAiAgentConfigShowResponse,
} from '../../types/WhatsAppAiAgentConfigShow'

export const whatsAppAiAgentConfigShowQueryKey = (campaignId: WhatsAppAiAgentConfigShowPathParams['campaignId']) =>
	[{ url: '/campaigns/:campaignId/whatsapp-ai-config', params: { campaignId } }] as const

export type WhatsAppAiAgentConfigShowQueryKey = ReturnType<typeof whatsAppAiAgentConfigShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::show */
export function whatsAppAiAgentConfigShowQueryOptions(
	campaignId: WhatsAppAiAgentConfigShowPathParams['campaignId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAiAgentConfigShowResponse,
		AxiosError<WhatsAppAiAgentConfigShowError>,
		WhatsAppAiAgentConfigShowResponse,
		WhatsAppAiAgentConfigShowQueryKey
	>({
		queryKey: whatsAppAiAgentConfigShowQueryKey(campaignId),
		queryFn: ({ signal }) => whatsAppAiAgentConfigShow(campaignId, { signal, ...config }).then(res => res.data),
		enabled: !!campaignId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::show */
export function useWhatsAppAiAgentConfigShow<TSelectData = WhatsAppAiAgentConfigShowResponse>(
	campaignId: WhatsAppAiAgentConfigShowPathParams['campaignId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAiAgentConfigShowResponse,
					AxiosError<WhatsAppAiAgentConfigShowError>,
					TSelectData,
					WhatsAppAiAgentConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAiAgentConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAiAgentConfigShowQueryOptions(campaignId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::show */
export function useWhatsAppAiAgentConfigShowSuspense<TSelectData = WhatsAppAiAgentConfigShowResponse>(
	campaignId: WhatsAppAiAgentConfigShowPathParams['campaignId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAiAgentConfigShowResponse,
					AxiosError<WhatsAppAiAgentConfigShowError>,
					TSelectData,
					WhatsAppAiAgentConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAiAgentConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAiAgentConfigShowQueryOptions(campaignId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
